import React, { useState } from 'react';
import userService from '../../services/userService';
import { useUI } from '../../context/UIContext';

const QuickUserSearchPage: React.FC = () => {
  const { showSnackbar } = useUI();
  const [q, setQ] = useState('');
  const [role, setRole] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any[]>([]);

  const search = async () => {
    if (q.trim().length < 2 && !role) {
      showSnackbar('Enter at least 2 characters, or select a role to list users.', 'error');
      return;
    }
    setLoading(true);
    try {
      const data = await userService.searchUsers(q.trim(), {
        userType: role || undefined,
        limit: 50,
      });
      setRows(Array.isArray(data) ? data : []);
    } catch {
      showSnackbar('Search failed.', 'error');
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page" style={{ padding: 24, maxWidth: 960 }}>
      <h1 style={{ marginBottom: 16 }}>Quick user search</h1>
      <p style={{ color: '#666', marginBottom: 16 }}>
        Search by name, email, or phone. Filter by role when needed.
      </p>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
        <input
          style={{ flex: 1, minWidth: 200, padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
          placeholder="Search…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <select
          style={{ padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
          value={role}
          onChange={(e) => setRole(e.target.value)}>
          <option value="">Any role</option>
          <option value="client">Client</option>
          <option value="stylist">Stylist</option>
          <option value="admin">Admin</option>
        </select>
        <button
          type="button"
          style={{
            padding: '10px 20px',
            background: '#C9A84C',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
          }}
          disabled={loading}
          onClick={search}>
          {loading ? 'Searching…' : 'Search'}
        </button>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {rows.map((u) => (
          <div
            key={u._id}
            style={{
              border: '1px solid #eee',
              borderRadius: 10,
              padding: 14,
              background: '#fff',
            }}>
            <strong>{u.name}</strong>
            <div style={{ color: '#555', fontSize: 14 }}>{u.email}</div>
            <div style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
              {u.userType}
              {u.adminRole ? ` · ${u.adminRole}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickUserSearchPage;
